var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.54716L20.5 5.32494V11C20.5 16.2973 16.8574 21.2335 12 22.4845C7.14262 21.2335 3.5 16.2973 3.5 11V5.32494L12 1.54716Z",
    stroke: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 11.9091L15.2 7.81818C15.0333 7.34364 14.5667 7 14.0167 7H9.85C9.3 7 8.83333 7.34364 8.66667 7.81818L7 11.9091V15.1818C7 15.6318 7.375 16 7.83333 16H8.66667C9.125 16 9.5 15.6318 9.5 15.1818V14.3636H14.5V15.1818C14.5 15.6318 14.875 16 15.3333 16H16.1667C16.625 16 17 15.6318 17 15.1818V11.9091ZM13.6667 12.7273C13.6667 12.2773 14.0417 11.9091 14.5 11.9091C14.9583 11.9091 15.3333 12.2773 15.3333 12.7273C15.3333 13.1773 14.9583 13.5455 14.5 13.5455C14.0417 13.5455 13.6667 13.1773 13.6667 12.7273ZM14.0167 8.22727L15.3333 11.0909H8.66667L9.85 8.22727H14.0167ZM8.66667 12.7273C8.66667 12.2773 9.04167 11.9091 9.5 11.9091C9.95833 11.9091 10.3333 12.2773 10.3333 12.7273C10.3333 13.1773 9.95833 13.5455 9.5 13.5455C9.04167 13.5455 8.66667 13.1773 8.66667 12.7273Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutShield);
export default __webpack_public_path__ + "static/media/aboutShield.3fd6e6863b7c8a0272a9e6ba18200051.svg";
export { ForwardRef as ReactComponent };